export default __webpack_public_path__ + "static/media/Summoner's Boots of Sovereign Rule.40a484a1.jpg";